export default __webpack_public_path__ + "static/media/DeepOceanOmega500x900v2.87a89a85.jpg";